<template id="templateStyling">
  <div class="navMenu" id="navMenu" :style="{ backgroundColor: orgBackgroundColor }">
    <!-- Welcome Message -->
    <div class="navMenuHeader">
      <div class="welcome-container">
        <div v-if="!minimized">
          <p class="welcome-name">
            {{ `Hi ${this.userFirstName ?? ""}` }}
          </p>
          <p class="welcome-message">Welcome Back!</p>
        </div>
        <div v-else>
          <p class="welcome-message-minimized">R</p>
        </div>
      </div>
      <div>
        <button id="closeNavMenuButton" v-on:click="() => handleNavMenuClose()">
          <i class="fa fa-chevron-left"
            style="width:20px;height: 20px;font-size:20px;color:white;font-weight: 100;"></i>
        </button>
      </div>

    </div>

    <div v-bind:key="navigationItem.id" v-for="navigationItem in navigation">
      <!-- v-on:selectItem="emitMethod(navigationItem.title)" -->
      <NavItem v-bind:navigationItem="navigationItem"
        :selected="determineSelected(navigationItem.title)" :minimized="minimized" />
    </div>
    <button id="minimizeButton" @click="minimizeNavbar" name="Minimize">&lt;</button>
  </div>
</template>
<script>
import NavItem from "./NavItem";
import EventBus from "../eventBus";
import * as Constants from "../js/constants";

export default {
  name: "NavigationMenu",
  components: {
    NavItem,
  },
  props: ["userData", "navigation", 'organizationData'],
  data() {
    return {
      activeItem: Constants.HOME,
      minimized: false,
      userFirstName: this.$props.userData.name,
      userLastName: this.$props.userData.family_name,
      orgBackgroundColor: "#699991"
    };
  },
  watch: {
    userData: function (newVal, oldVal) {
      console.log("userData changed: ", newVal, " | was: ", oldVal);
      this.userId = newVal.sub;
      this.userFirstName = this.$props.userData.name
      this.userLastName = this.$props.userData.family_name
    },
    organizationData: function () {
      //this.orgBackgroundColor = this.$organizationConfig.colorMap.colorPrimary
      this.orgBackgroundColor = this.$organizationConfig.colorMap.colorPrimary
    }
  },
  created() {
    EventBus.$on('toggle-navigation-visibility', () => {
      let navMenu = document.getElementById('navMenu')
      if (navMenu.style.visibility == "" || navMenu.style.visibility == "hidden") {
        navMenu.style.display = "block"
        navMenu.style.visibility = "visible"
      } else {
        navMenu.style.display = "none"
        navMenu.style.visibility = "hidden"
      }
    })
  },
  beforeMount() {
    const path = window.location.pathname;
    console.log("Active Content.vue querystring", path);
    const filteredPath = path.replace('/', '')
    this.activeItem = filteredPath
  },
  methods: {
    emitMethod(selector) {
      let navItems = Array.from(document.getElementsByClassName("active"));
      console.log("navItems", navItems);
      for (let item in navItems) {
        console.log(item, navItems[item]);
        //var element = navItems[item];

        //element.classList.remove("active");
      }
      var eventTitle = Constants.NAVIGATION_ITEM_SELECTED;
      EventBus.$emit(eventTitle, selector);
    },
    determineSelected(title) {
      let decodedActiveItem = decodeURI(this.activeItem)
      if (decodedActiveItem.includes(title)) {
        return true;
      } else {
        return false;
      }
    },
    minimizeNavbar() {
      let div = document.getElementById("navMenu");
      let button = document.getElementById("minimizeButton");
      if (this.minimized) {
        div.classList.remove("minimized")
        button.innerHTML = "<"
        this.minimized = false
      } else {
        div.classList.add("minimized");
        button.innerHTML = ">"
        this.minimized = true

      }
    },
    handleNavMenuClose() {
      EventBus.$emit('toggle-navigation-visibility')
    }
  },
};
</script>

<style scoped>
@media (0px <=width <=600px) {
  .navMenu {
    /* what should the dynamic scaling and min-width be set to */
    max-width: 40vw;
    height: 100vh;
    flex-direction: column;
    background-color: #699991;
    position: fixed;
    top: 0px;
    left: 0px;
    transition: 0s;
    float: left;
    z-index: 5;
    visibility: hidden;
  }

  .minimized {
    width: 80px;
    transition: .8s;
  }

  .navText {
    text-align: center;
    display: block;
    margin: auto;
  }

  #templateStyling {
    height: 100%;
  }

  #minimizeButton {
    display: none;
  }

  .navMenuHeader {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 16px;
  }

  .welcome-container {
    color: white;
    text-align: left;
    margin-bottom: 28px;
  }

  .welcome-name {}

  .welcome-message {
    font-weight: bold;
  }
}

@media (width > 600px) {
  .navMenu {
    /* what should the dynamic scaling and min-width be set to */
    width: 250px;
    height: calc(100vh - 72px);
    flex-direction: column;
    background-color: #699991;
    position: sticky;
    padding-top: 16px;
    top: 72px;
    transition: .8s;
    float: left;
    z-index: 2;
  }

  #closeNavMenuButton {
    display: none;
  }

  .minimized {
    width: 80px;
    transition: .8s;
  }

  .navText {
    text-align: center;
    display: block;
    margin: auto;
  }

  #templateStyling {
    height: 100%;
  }

  #minimizeButton {
    position: absolute;
    height: 24px;
    width: 24px;
    top: 48px;
    left: calc(100% - 12px);
    background: white;
    border: 1px solid #87bab7;
    border-radius: 12px;
    color: #87bab7;
    font-size: 18px;
    text-decoration: bold;
  }

  .welcome-container {
    padding-left: 12px;
    color: white;
    text-align: left;
    margin-bottom: 28px;
  }

  .welcome-name {}

  .welcome-message {
    font-weight: bold;
  }
}
</style>